import 'dayjs/locale/mk'
import { Dayjs } from 'dayjs'

const mk = {
  calendar: {
    sameDay: '[Денес во] LT',
    nextDay: '[Утре во] LT',
    nextWeek: '[Во] dddd [во] LT',
    lastDay: '[Вчера во] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
        case 3:
        case 6:
          return now.format('[Изминатата] dddd [во] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[Изминатиот] dddd [во] LT')
      }
    },
    sameElse: 'L'
  }
}

export default mk
